import http from '@/services/api';

const RESOURCE_NAME = 'api/supervisor';

export default {
  registerSupervisor({ terminal, useInternalPhone }) {
    return http.get(`${RESOURCE_NAME}/register`, { params: { terminal, useInternalPhone } });
  },

  isSupervisorRegistered() {
    return http.get(`${RESOURCE_NAME}/registered`);
  },

  getSupervisedBusinessProcesses(supervisorId) {
    return http.get(`${RESOURCE_NAME}/${supervisorId}/businessProcess/all`);
  },

  getBusinessProcessHealthThresholds(supervisorId, businessProcessId) {
    return http.get(`${RESOURCE_NAME}/${supervisorId}/businessProcess/${businessProcessId}/health/thresholds`);
  },

  addBusinessProcessHealthThresholds(supervisorId, businessProcessId, kpis, name) {
    return http.post(`${RESOURCE_NAME}/${supervisorId}/businessProcess/${businessProcessId}/health/thresholds`, {
      name,
      kpis
    });
  },

  addHealthThresholdsConfigurationToOtherBPs(supervisorId, name, kpis, bpIds) {
    return http.post(`${RESOURCE_NAME}/${supervisorId}/health/thresholds/add-to-other-business-processes`, {
      healtThresholds: {
        active: false,
        name,
        kpis
      },
      bpIds
    });
  },

  addAndApplyHealthThresholdsConfigurationToOtherBPs(supervisorId, name, kpis, bpIds) {
    return http.post(`${RESOURCE_NAME}/${supervisorId}/health/thresholds/and-and-apply-to-other-business-processes`, {
      healtThresholds: {
        active: true,
        name,
        kpis
      },
      bpIds
    });
  },

  updateBusinessProcessHealthThresholds(supervisorId, businessProcessId, id, kpis, name, active) {
    return http.put(`${RESOURCE_NAME}/${supervisorId}/businessProcess/${businessProcessId}/health/thresholds`, {
      id,
      active,
      name,
      kpis
    });
  },

  deleteBusinessProcessHealthThreshold(supervisorId, businessProcessId, id) {
    return http.delete(`${RESOURCE_NAME}/${supervisorId}/businessProcess/${businessProcessId}/health/thresholds/${id}`);
  },

  updateAnotherAgentState(agentId, stateId) {
    return http.put(`${RESOURCE_NAME}/agent/${agentId}/state`, {
      stateId
    });
  },

  updateAnotherAgentLoadAllowance(agentId, loadAllowanceId) {
    return http.post(`${RESOURCE_NAME}/agent/${agentId}/loadAllowance`, {
      loadAllowanceId
    });
  },

  getAnotherAgentLoadAllowances(agentId) {
    return http.get(`${RESOURCE_NAME}/agent/${agentId}/loadAllowance`);
  },

  listenToAgentAction(agentId, action) {
    return http.post(`${RESOURCE_NAME}/listen/${agentId}/${action}`);
  },

  recordToAgentAction(agentId, action) {
    return http.post(`${RESOURCE_NAME}/record/${agentId}/${action}`);
  },

  coachToAgentAction(agentId, action) {
    return http.post(`${RESOURCE_NAME}/coach/${agentId}/${action}`);
  },

  interveneToAgentAction(agentId, action) {
    return http.post(`${RESOURCE_NAME}/intervene/${agentId}/${action}`);
  },

  getSupervisedAgents(supervisorId) {
    return http.get(`${RESOURCE_NAME}/${supervisorId}/supervisedAgent/all`);
  },

  getSupervisedInteractions(supervisorId) {
    return http.get(`${RESOURCE_NAME}/${supervisorId}/supervisedInteraction/all`);
  }
};
